import { purchaseRepository } from '../repositories/purchase-repository';

function getPurchaseData() {
    return purchaseRepository.get();
}

function savePurchaseSubscription(subscriptionId, plan, discount) {
    return purchaseRepository.saveSubscription(subscriptionId, plan, discount);
}

function savePurchaseProduct(productId) {
    return purchaseRepository.saveProduct(productId);
}

export {
    getPurchaseData,
    savePurchaseSubscription,
    savePurchaseProduct
};
